import { MedicalAppointmentFormData } from 'components/MedicalRequestForm/schema'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import MedicalRequestService from 'services/medicalRequest'
import { useDebounce } from 'hooks/useDebounce'
import { Option } from '../../types/option'
import { SearchSelect } from '../SearchMultiSelect'

export const DiagnosticHypothesesSelect = () => {
  const [options, setOptions] = React.useState<Option[]>([])
  const [searchQuery, setSearchQuery] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const debouncedSearchQuery = useDebounce(searchQuery, 300)
  const { control, watch } = useFormContext<MedicalAppointmentFormData>()
  const selected = watch('cid')

  const fetchDiagnostics = React.useCallback(async (query: string, page: number, isSearch = false) => {
    setLoading(true)
    try {
      const result = await MedicalRequestService.listAllDiagnosticHypotheses(query, page)

      const newOptions = result.diagnosticHypotheses.map(({ id, description, cidCode }) => ({
        id,
        name: `${description} (CID ${cidCode})`
      }))

      setOptions(state => isSearch ? newOptions : [...state, ...newOptions])
      return result
    } finally {
      setLoading(false)
    }
  }, [])

  React.useEffect(() => {
    if (debouncedSearchQuery.length >= 2) {
      fetchDiagnostics(debouncedSearchQuery, 1, true)
    } else if (debouncedSearchQuery.length === 0) {
      fetchDiagnostics('', 1, true)
    }
  }, [debouncedSearchQuery, fetchDiagnostics])

  React.useEffect(() => {
    fetchDiagnostics('', 1, true)
  }, [fetchDiagnostics])

  return (
    <Controller
      control={control}
      name="cid"
      render={({ field, fieldState: { error }}) => (
        <SearchSelect
          id='diagnostic-hypotheses-select'
          {...field}
          options={options}
          selectedOption={selected}
          loadOptions={fetchDiagnostics}
          onSearchChange={setSearchQuery}
          loading={loading}
          floatingLabel="CID (letra e números)*"
          inputPlaceholder="Digite e/ou selecione para adicionar"
          emptyOptionsMessage="Nenhum resultado. Verifique sua digitação."
          helperMessage="O CID (Código Internacional de Doenças) consta no pedido médico. Digite e/ou selecione na lista para adicionar."
          hasError={Boolean(error?.message)}
          messageError={error?.message}
        />
      )}
    />
  )
}
